export default __webpack_public_path__ + "static/236f4521b163dddbbf7bb957e5681f19.png";